module.exports = __webpack_public_path__ + "img/12.740a4fc5.png";